import React, { FC } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { EscalationRule } from 'types/assist/assistMigration';

interface EscalationEditorProps {
  items: EscalationRule[];
  onChange: (next: EscalationRule[]) => void;
}

export const EscalationEditor: FC<EscalationEditorProps> = ({ items, onChange }) => (
  <div>
    {items.map((rule, index) => (
      <div key={index} style={{ display: 'flex', gap: 8, marginBottom: 6 }}>
        <TextField
          size="small"
          label="Condition"
          value={rule.condition}
          fullWidth
          onChange={(event) =>
            onChange(
              items.map((it, i) => (i === index ? { ...it, condition: event.target.value } : it)),
            )
          }
        />
        <TextField
          size="small"
          label="Phone"
          value={rule.phone}
          onChange={(event) =>
            onChange(
              items.map((it, i) => (i === index ? { ...it, phone: event.target.value } : it)),
            )
          }
        />
        <Button
          size="small"
          color="error"
          onClick={() => onChange(items.filter((_, i) => i !== index))}
        >
          ×
        </Button>
      </div>
    ))}
    <Button size="small" onClick={() => onChange([...items, { condition: '', phone: '' }])}>
      + rule
    </Button>
  </div>
);
